<div class="app-shell">
  <aside class="sidebar" [class.open]="sidebarOpen()">
    <app-sidemenu [activeKey]="activeKey()" />
  </aside>

  <div class="sidebar-overlay" [class.open]="sidebarOpen()" (click)="closeSidebar()"></div>

  <div class="main-column">
    <header class="topbar">
      <app-navbar [activeKey]="activeKey()" (toggleSidebar)="toggleSidebar()" />
    </header>
    <main class="content">
      <router-outlet />
    </main>
  </div>
</div>

<app-confirm-host />
